import { React, useState, useEffect } from 'react'
import { motion } from "framer-motion";
import { Helmet } from 'react-helmet'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShieldHalved, faRightFromBracket, faCalendarDays, faUserShield, faArrowRight, faCircleCheck, faClock, faUserPen, faCircleInfo, faEnvelope, faBolt } from '@fortawesome/free-solid-svg-icons'

import MainHeader from '../../../components/MainHeader/MainHeader.js'
import MainFooter from '../../../components/MainFooter/MainFooter.js'
import Skeleton from '../../../components/Skeleton/Skeleton.js'

import { lP, oP, sT, boxvar2_1, boxvar2_2, boxvar2_3, boxvar4, URL_MAINAPI, API_TOKEN, formatDateWithTime, capFirstChar, sortEventsByDateStartDesc } from '../../../main.js'

import '../../../main.css'
import './ProfilOverview.css'
import './MProfilOverview.css'

import Cookies from 'universal-cookie'

export default function ProfilOverview() {

    var [resError, setResError] = useState("")

    const cookies = new Cookies()
    let cur_userid = cookies.get('userid')
    let cur_firstname = cookies.get('firstname')
    let cur_lastname = cookies.get('lastname')
    let cur_authtoken = cookies.get('authtoken')
    let loggedin = (cur_userid != "" && cur_userid != undefined)

    var [userEventData, setUserEventData] = useState([])
    var [loadedUserEventData, setLoadedUserEventData] = useState(0)
    var [userOrgData, setUserOrgData] = useState([])
    var [loadedUserOrgData, setLoadedUserOrgData] = useState(0)
    var [userMe, setUserMe] = useState(null)
    var [unreadCount, setUnreadCount] = useState(0)

    useEffect(() => {
        getUserEvents()
        getUserOrgs()
        getUserMe()
        getUnreadCount()
    }, [])

    function getUnreadCount() {
        try {
            fetch(URL_MAINAPI + "/mailing/unreadcount", {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200 && res.data && res.data.data) {
                    setUnreadCount(res.data.data.count || 0)
                } else {
                    setUnreadCount(0)
                }
            }))
        } catch (err) {
            setUnreadCount(0)
        }
    }

    function getUserMe() {
        try {
            fetch(URL_MAINAPI + "/user/me", {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    setUserMe(res.data)
                } else {
                    setUserMe(null)
                }
            }))
        } catch (err) {
            setUserMe(null)
        }
    }

    function getUserEvents() {
        try {
            setLoadedUserEventData(0)
            fetch(URL_MAINAPI + "/user/userevents", {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    setUserEventData(sortEventsByDateStartDesc(res.data))
                    setLoadedUserEventData(1)
                } else {
                    setUserEventData([])
                    setLoadedUserEventData(0)
                }
            }))
        } catch (err) {
            setUserEventData([])
            setLoadedUserEventData(0)
        }
    }

    function getUserOrgs() {
        try {
            setLoadedUserOrgData(0)
            fetch(URL_MAINAPI + "/user/manageroforgs", {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    setUserOrgData(res.data)
                    setLoadedUserOrgData(1)
                } else {
                    setUserOrgData([])
                    setLoadedUserOrgData(0)
                }
            }))
        } catch (err) {
            setUserOrgData([])
            setLoadedUserOrgData(0)
        }
    }

    function doLogout() {
        const userCookies = Object.keys(cookies.getAll());
        userCookies.forEach((key) => cookies.remove(key));
        window.location.href = "/login";
    }

    let initials = ''
    if (cur_firstname && cur_lastname) {
        initials = (cur_firstname.charAt(0) + cur_lastname.charAt(0)).toUpperCase()
    } else if (cur_firstname) {
        initials = cur_firstname.charAt(0).toUpperCase()
    }

    const isHelferzeitAdmin = !!(userMe && userMe.helferzeit_admin == 1)

    return (
        <div className='mainCon page' id='mainCon'>
            <MainHeader selectedsite={""} />
            <Helmet>
                <meta charSet="utf-8" />
                <title>Profil</title>
                <meta property="og:title" content="Profil" />
                <meta property="og:description" content="Verwalte dein Profil" />
            </Helmet>

            <main className='page-body container section'>
                <div className='section-eyebrow'>Dein Bereich</div>
                <motion.h1
                    variants={boxvar4}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, margin: "-50px" }}
                    className='section-title'
                >
                    Hallo {cur_firstname}!
                </motion.h1>
                <p className='section-sub'>Hier findest du deine Events und deine Organisationen.</p>

                {/* Profilkarte */}
                <motion.div
                    variants={boxvar2_1}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, margin: "-50px" }}
                >
                    <div className='card profile-card'>
                        <div className='profile-row'>
                            <div className={'profile-avatar' + (isHelferzeitAdmin ? ' profile-avatar-admin' : '')}>{initials || '?'}</div>
                            <div>
                                <h2>
                                    {cur_firstname} {cur_lastname}
                                    {isHelferzeitAdmin ? (
                                        <span className='profile-admin-mark' title="Helferzeit-Team (Admin)" aria-label="Helferzeit-Team (Admin)">
                                            <FontAwesomeIcon icon={faBolt} />
                                        </span>
                                    ) : null}
                                </h2>
                            </div>
                        </div>
                        {/* TODO: Add password change callout */}
                        <div className='profile-actions'>
                            <a href='/profil/edit' className='btn btn-secondary btn-sm'>
                                <FontAwesomeIcon icon={faUserPen} /> Profil bearbeiten
                            </a>
                            <a href='/profil/messages' className='btn btn-secondary btn-sm'>
                                <FontAwesomeIcon icon={faEnvelope} /> Benachrichtigungen
                                {unreadCount > 0 ? <span className='badge badge-brand profile-unread-badge'>{unreadCount}</span> : null}
                            </a>
                            <a href='/profil/sicherheit' className='btn btn-secondary btn-sm'>
                                <FontAwesomeIcon icon={faShieldHalved} /> Accountsicherheit
                            </a>
                            <a
                                href="#"
                                onClick={(e) => { e.preventDefault(); doLogout() }}
                                className='btn btn-quiet btn-sm'
                                style={{ color: 'var(--error)' }}
                            >
                                <FontAwesomeIcon icon={faRightFromBracket} /> Abmelden
                            </a>
                        </div>

                    </div>
                    {isHelferzeitAdmin ? (
                        <div className='profile-callout profile-callout-admin'>
                            <FontAwesomeIcon icon={faBolt} />
                            <div>
                                <b>Helferzeit-Team</b>
                                <p>Alle Organisationen und Events verwalten, Organisationen anlegen und Plattform-Rundmails versenden.</p>
                            </div>
                            <a href='/admin' className='btn btn-accent btn-sm'>
                                Admin-Bereich <FontAwesomeIcon icon={faArrowRight} />
                            </a>
                        </div>
                    ) : null}
                    {(userMe && userMe.haspassword === false && !userMe.haspasskey) ? (
                        <>
                            <br />
                            <div className='profile-callout'>
                                <FontAwesomeIcon icon={faCircleInfo} />
                                <div>
                                    <b>Du nutzt noch den E-Mail-Login.</b>
                                    <p>Richte einen Passkey oder ein Passwort ein, um dich künftig ohne E-Mail-Link anmelden zu können.</p>
                                </div>
                                <a href='/profil/sicherheit' className='btn btn-primary btn-sm'>
                                    Jetzt einrichten
                                </a>
                            </div>
                        </>
                    ) : null}
                </motion.div>

                {/* Meine Events */}
                <motion.div
                    className='section-gap'
                    variants={boxvar2_2}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, margin: "-50px" }}
                >
                    <h2 className='subsection-title'>
                        Meine Events
                        {userEventData.length > 0 ? <span className='badge badge-brand' style={{ marginLeft: '8px' }}>{userEventData.length}</span> : null}
                    </h2>

                    {(!loadedUserEventData) ? <Skeleton variant="grid" cols={3} count={3} /> : null}
                    {loadedUserEventData && userEventData.length === 0 ? (
                        <p style={{ color: 'var(--text-secondary)' }}>Du bist aktuell bei keinen Events angemeldet.</p>
                    ) : null}

                    <div className='grid grid-3 profile-events-grid' style={{ marginTop: '16px' }}>
                        {userEventData.map(function (event) {
                            return (
                                <div
                                    key={event._id}
                                    className="card card-hover event-mini noselect"
                                    onClick={() => lP('/event/' + event._id)}
                                    role="button"
                                    tabIndex={0}
                                    onKeyDown={(e) => { if (e.key === 'Enter') lP('/event/' + event._id) }}
                                >
                                    <div className='event-mini-top'>
                                        <h3>{event.name}</h3>
                                        {(event.eventscheduleregistered) ? (
                                            <span className='badge badge-open'><FontAwesomeIcon icon={faCircleCheck} /> Dienste gewählt</span>
                                        ) : (
                                            <span className='badge badge-accent'><FontAwesomeIcon icon={faClock} /> unvollständig</span>
                                        )}
                                    </div>
                                    <span className='event-mini-meta'>
                                        <FontAwesomeIcon icon={faCalendarDays} /> von {event.orgname}
                                    </span>
                                    <div className='event-mini-actions'>
                                        {(event.eventscheduleregistered) ? (
                                            <a href={'/eventplannedschedule/' + event._id} className='btn btn-primary btn-sm'>
                                                Mein Dienstplan <FontAwesomeIcon icon={faArrowRight} />
                                            </a>
                                        ) : (
                                            <a href={'/eventregisterschedule/' + event._id} className='btn btn-primary btn-sm'>
                                                Zur Dienstplanung <FontAwesomeIcon icon={faArrowRight} />
                                            </a>
                                        )}
                                        <a
                                            href={'/profil/messages/' + event._id}
                                            className='btn btn-quiet btn-sm'
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <FontAwesomeIcon icon={faEnvelope} /> Nachrichten
                                        </a>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </motion.div>

                {/* Meine Organisationen */}
                <motion.div
                    className='section-gap'
                    variants={boxvar2_3}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, margin: "-50px" }}
                >
                    <h2 className='subsection-title'>
                        Meine Organisationen
                        {userOrgData.length > 0 ? <span className='badge badge-accent' style={{ marginLeft: '8px' }}>{userOrgData.length}</span> : null}
                    </h2>

                    {(!loadedUserOrgData) ? <Skeleton variant="grid" cols={2} count={2} /> : null}
                    {loadedUserOrgData && userOrgData.length === 0 ? (
                        <p style={{ color: 'var(--text-secondary)' }}>Du bist kein Manager in einer Organisation.</p>
                    ) : null}
                    {loadedUserOrgData ? (
                        <p className='profile-hint' style={{ marginTop: userOrgData.length === 0 ? '10px' : '8px', marginBottom: 0 }}>
                            {isHelferzeitAdmin ? (
                                <>Als Helferzeit-Admin findest du alle Organisationen und das Anlegen neuer Organisationen im <a href="/admin">Admin-Bereich</a>.</>
                            ) : (
                                <>
                                    Eine neue Organisation kann nicht selbst angelegt werden – bitte melde dich dafür über{' '}
                                    <a href="https://www.helferzeit.de/support" target="_blank" rel="noopener noreferrer">www.helferzeit.de/support</a>.
                                </>
                            )}
                        </p>
                    ) : null}

                    <div className='grid grid-2 profile-orgs-grid' style={{ marginTop: '16px' }}>
                        {userOrgData.map(function (org) {
                            return (
                                <div
                                    key={org._id}
                                    className="card card-hover event-mini noselect"
                                    onClick={() => lP('/manage/org/' + org._id)}
                                    role="button"
                                    tabIndex={0}
                                    onKeyDown={(e) => { if (e.key === 'Enter') lP('/manage/org/' + org._id) }}
                                >
                                    <div className='event-mini-top'>
                                        <div>
                                            <h3>{org.name}</h3>
                                            <span className='event-mini-meta'>
                                                <FontAwesomeIcon icon={faUserShield} /> Deine Rolle: Organisator
                                            </span>
                                        </div>
                                    </div>
                                    <a href={'/manage/org/' + org._id} className='btn btn-primary btn-sm'>
                                        Verwalten <FontAwesomeIcon icon={faArrowRight} />
                                    </a>
                                </div>
                            )
                        })}
                    </div>
                </motion.div>
            </main>

            <MainFooter useEventStyle={false} />
        </div>
    )
}
